/** 通用错误提示：ErrorAlert / toastError 与 lib/api.ts 的兜底错误文案（服务端未给出信息时）。 */
const messages = {
  loadFailed: '加载失败',
  requestId: '请求 ID',
  retry: '重试',
  'toast.withTitle': '{title}：{message}',
  'toast.requestId': '请求 ID：{id}',
  'http.401': '登录已过期，请重新登录。',
  'http.403': '没有权限执行该操作。',
  'http.404': '请求的资源不存在。',
  'http.429': '请求过于频繁，请稍后再试。',
  'http.5xx': '服务暂时不可用，请稍后重试。',
  'http.other': '请求失败（HTTP {status}）。',
  network: '无法连接服务器，请检查网络后重试。',
  unknown: '操作失败，请稍后重试。',
};

export default messages;
